require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/fn/is-iterable.js
// module id = ../../../../core-js/library/fn/is-iterable.js
// module chunks = 7